import React, { useState, useContext } from "react";
import {
  ALL_HOLIDAYS_QUERY,
  HOLIDAYS_PAGINATION_QUERY
} from "../../../graphql/Holidays/Holidays.graphql";
import DataTable from "../../../components/DataTable";

import { ModalContext } from "../../../components/ModalProvider";

import {
  AddHolidayForm,
  EditHolidayForm
} from "../../../components/HolidaySchedule";

import { COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";

import HolidayScheduleFilters from "./HolidayScheduleFilters";
import { getFilterState, saveFilterState } from "../../../utils";

function HolidayPage() {
  const INITIAL_FILTER_STATE = getFilterState("HOLIDAY_FILTERS", {});
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const { setModalOpen } = useContext(ModalContext);

  const handleSetFilters = inputs => {
    saveFilterState("HOLIDAY_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({});
  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={HolidayScheduleFilters}
        columns={COLUMNS}
        filters={filters}
        name="Holidays"
        query={ALL_HOLIDAYS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Holidays"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddHolidayForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_HOLIDAYS_QUERY}
        initialSortBy={[{ id: "HolidayDate", desc: true }]}
        name="Holiday"
        paginationQuery={HOLIDAYS_PAGINATION_QUERY}
        where={filters}
        onRowClick={holiday =>
          setModalOpen(
            true,
            <EditHolidayForm
              holiday={holiday}
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
}

HolidayPage.propTypes = {};
export default HolidayPage;
